var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphDotStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Graph-Dot--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Graph Dot Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph-dot--product-data-bars-analysis-analytics-graph-business-chart-dot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "M11.937857142857144 19.233214285714286c2.9712000000000005 0 4.6425 -1.6713 4.6425 -4.6425S14.909057142857144 9.948214285714286 11.937857142857144 9.948214285714286s-4.6425 1.6713 -4.6425 4.6425 1.6713 4.6425 4.6425 4.6425Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.937857142857144 19.233214285714286c2.9712000000000005 0 4.6425 -1.6713 4.6425 -4.6425S14.909057142857144 9.948214285714286 11.937857142857144 9.948214285714286s-4.6425 1.6713 -4.6425 4.6425 1.6713 4.6425 4.6425 4.6425Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#ffffff",
    d: "M30.507857142857144 11.274642857142858c2.9712000000000005 0 4.6425 -1.6713 4.6425 -4.6425S33.479057142857144 1.9896428571428573 30.507857142857144 1.9896428571428573s-4.6425 1.6713 -4.6425 4.6425 1.6713 4.6425 4.6425 4.6425Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.507857142857144 11.274642857142858c2.9712000000000005 0 4.6425 -1.6713 4.6425 -4.6425S33.479057142857144 1.9896428571428573 30.507857142857144 1.9896428571428573s-4.6425 1.6713 -4.6425 4.6425 1.6713 4.6425 4.6425 4.6425Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fill: "#ffffff",
    d: "M23.875714285714288 28.518214285714286c2.9712000000000005 0 4.6425 -1.6713 4.6425 -4.6425S26.846914285714284 19.233214285714286 23.875714285714288 19.233214285714286 19.233214285714286 20.90451428571429 19.233214285714286 23.875714285714288s1.6713 4.6425 4.6425 4.6425Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.875714285714288 28.518214285714286c2.9712000000000005 0 4.6425 -1.6713 4.6425 -4.6425S26.846914285714284 19.233214285714286 23.875714285714288 19.233214285714286 19.233214285714286 20.90451428571429 19.233214285714286 23.875714285714288s1.6713 4.6425 4.6425 4.6425Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 190",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.787589285714287 18.321294642857143 1.9896428571428573 25.9068213",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 191",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m29.676717000000004 11.215696371428573 -2.650734857142857 8.929437557142858",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 192",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.217658514285713 16.692732171428574 3.8343336000000003 4.219952914285714",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 332",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.9896428571428573 1.9896428571428573v27.855c0 2.930346 2.3754478714285714 5.305714285714286 5.305714285714286 5.305714285714286h27.855",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphDotStreamlineFlex);
export default __webpack_public_path__ + "static/media/Graph-Dot--Streamline-Flex.9d78bc25e7f692fe5ad883fa052d670b.svg";
export { ForwardRef as ReactComponent };